export type ThemeMode = 'dark' | 'light';

export const THEME_STORAGE_KEY = 'o4t-theme';

export const DEFAULT_THEME: ThemeMode = 'dark';

/**
 * Runs in `<head>` before the first paint, so a light-mode visitor never sees a
 * frame of the dark palette. Kept as a string (not a component) because it must
 * execute synchronously ahead of hydration — anything React renders is too late.
 */
export const THEME_INIT_SCRIPT = `(function(){try{var t=localStorage.getItem(${JSON.stringify(
    THEME_STORAGE_KEY,
)});if(t==="light"||t==="dark"){document.documentElement.dataset.theme=t}}catch(e){}})()`;
